export const countries: Record<string,string> = {
    "Australia": "AU",
    "Austria": "AT",
    "Belgium": "BE",
    "Canada": "CA",
    "Croatia": "HR",
    "Czech Republic": "CZ",
    "Denmark": "DK",
    "Finland": "FI",
    "France": "FR",
    "Germany": "DE",
    "Hungary": "HU",
    "India": "IN",
    "Ireland": "IE",
    "Italy": "IT",
    "Japan": "JP",
    "Netherlands": "NL",
    "Norway": "NO",
    "Poland": "PL",
    "Portugal": "PT",
    "Romania": "RO",
    "Russia": "RU",
    "Serbia": "RS",
    "Slovakia": "SK",
    "Slovenia": "SI",
    "South Korea": "KR",
    "Spain": "ES",
    "Sweden": "SE",
    "Switzerland": "CH",
    "United Kingdom": "GB",
    "United States": "US"
}

export const scoreTypesGroup: Record<string, string> = {
    "PA": "Product Area (PA) level predictions (only available for existing PA_NO).",
    "PRA": "Product Range Area (PRA) level predictions (only available for existing PRA_NO).",
    "HFB": "Home Furnishing Business (HFB) level predictions"
}

export const validIkeaNos: Record<string, string[]> = {
  "PA": [
        "0111",
        "0112",
        "0113",
        "0114",
        "0115",
        "0121",
        "0125",
        "0126",
        "0131",
        "0132",
        "0133",
        "0142",
        "0152",
        "0153",
        "0161",
        "0162",
        "0163",
        "0164",
        "0211",
        "0212",
        "0213",
        "0214",
        "0215",
        "0216",
        "0217",
        "0221",
        "0222",
        "0223",
        "0231",
        "0241",
        "0242",
        "0311",
        "0312",
        "0313",
        "0316",
        "0317",
        "0321",
        "0322",
        "0323",
        "0331",
        "0341",
        "0342",
        "0343",
        "0351",
        "0352",
        "0353",
        "0354",
        "0361",
        "0371",
        "0411",
        "0412",
        "0413",
        "0417",
        "0421",
        "0422",
        "0423",
        "0424",
        "0431",
        "0432",
        "0433",
        "0435",
        "0511",
        "0512",
        "0513",
        "0514",
        "0515",
        "0521",
        "0522",
        "0523",
        "0524",
        "0525",
        "0584",
        "0611",
        "0612",
        "0621",
        "0622",
        "0623",
        "0631",
        "0632",
        "0633",
        "0634",
        "0636",
        "0642",
        "0711",
        "0712",
        "0713",
        "0715",
        "0716",
        "0721",
        "0722",
        "0723",
        "0731",
        "0732",
        "0733",
        "0741",
        "0742",
        "0743",
        "0744",
        "0746",
        "0751",
        "0752",
        "0761",
        "0762",
        "0763",
        "0771",
        "0772",
        "0773",
        "0774",
        "0775",
        "0776",
        "0777",
        "0778",
        "0779",
        "0781",
        "0782",
        "0783",
        "0791",
        "0792",
        "0811",
        "0812",
        "0814",
        "0821",
        "0822",
        "0823",
        "0824",
        "0825",
        "0911",
        "0914",
        "0918",
        "0921",
        "0922",
        "0923",
        "0924",
        "0925",
        "0931",
        "0933",
        "0934",
        "0937",
        "0938",
        "0939",
        "0942",
        "0944",
        "0945",
        "0951",
        "0956",
        "0961",
        "0962",
        "0963",
        "0964",
        "0965",
        "0966",
        "0967",
        "0971",
        "0972",
        "0973",
        "0974",
        "0981",
        "0982",
        "0983",
        "0984",
        "1011",
        "1012",
        "1013",
        "1014",
        "1015",
        "1016",
        "1018",
        "1019",
        "1021",
        "1022",
        "1023",
        "1024",
        "1031",
        "1032",
        "1041",
        "1043",
        "1045",
        "1051",
        "1052",
        "1061",
        "1081",
        "1082",
        "1111",
        "1112",
        "1113",
        "1121",
        "1122",
        "1123",
        "1124",
        "1131",
        "1132",
        "1133",
        "1135",
        "1211",
        "1213",
        "1214",
        "1221",
        "1231",
        "1232",
        "1233",
        "1311",
        "1313",
        "1314",
        "1321",
        "1411",
        "1412",
        "1413",
        "1414",
        "1415",
        "1421",
        "1422",
        "1423",
        "1424",
        "1431",
        "1432",
        "1433",
        "1434",
        "1511",
        "1512",
        "1521",
        "1522",
        "1531",
        "1541",
        "1542",
        "1551",
        "1552",
        "1621",
        "1622",
        "1623",
        "1624",
        "1631",
        "1632",
        "1633",
        "1634",
        "1635",
        "1636",
        "1637",
        "1641",
        "1642",
        "1643",
        "1644",
        "1645",
        "1711",
        "1712",
        "1713",
        "1714",
        "1715",
        "1716",
        "1717",
        "1718",
        "1719",
        "1721",
        "1731",
        "1811",
        "1812",
        "1813",
        "1814",
        "1815",
        "1821",
        "1822",
        "1823",
        "1831",
        "1832",
        "1833",
        "1836",
        "1841",
        "1851",
        "1852",
        "1871",
        "1881",
        "1882",
        "1911",
        "1912",
        "1921",
        "2018",
        "2021",
        "2042",
        "2044",
        "2051",
        "4021",
        "4022",
        "4042",
        "4072",
        "5011",
        "5031",
        "6011",
        "6012",
        "6013",
        "6014",
        "6015",
        "6016",
        "6021",
        "6022",
        "6023",
        "6031",
        "6032",
        "6033",
        "6041",
        "6042",
        "6043",
        "6044",
        "6091",
        "6092",
        "6093",
        "6094",
        "6095",
        "6096",
        "6097",
        "6098",
        "6099",
        "6111",
        "6112",
        "6113",
        "6121",
        "6122",
        "6131",
        "6132",
        "6133",
        "6134",
        "6141",
        "6142",
        "7023",
        "7031",
        "9411",
        "9412",
        "9414",
        "9612",
        "9613",
        "9614",
        "9615",
        "9616",
        "9617",
        "9618",
        "9619",
        "9621",
        "9622",
        "9623",
        "9625",
        "9626",
        "9627",
        "9628",
        "9636",
        "9655",
        "9656",
        "9658",
        "9661",
        "9662",
        "9711",
        "9714",
        "9717",
        "9718",
        "9721",
        "9722",
        "9726",
        "9727",
        "9732",
        "9733",
        "9736",
        "9737",
        "9738",
        "9743",
        "9745",
        "9746",
        "9747",
        "9748",
        "9749",
        "9751",
        "9752",
        "9753",
        "9754",
        "9755",
        "9762",
        "9763",
        "9767",
        "9771",
        "9772",
        "9773",
        "9781",
        "9782",
        "9783",
        "9784",
        "9785",
        "9791",
        "9793"
  ],
   "PRA": [
        "011",
        "012",
        "013",
        "014",
        "015",
        "016",
        "021",
        "022",
        "023",
        "024",
        "031",
        "032",
        "033",
        "034",
        "035",
        "036",
        "037",
        "041",
        "042",
        "043",
        "051",
        "052",
        "058",
        "061",
        "062",
        "063",
        "064",
        "071",
        "072",
        "073",
        "074",
        "075",
        "076",
        "077",
        "078",
        "079",
        "081",
        "082",
        "091",
        "092",
        "093",
        "094",
        "095",
        "096",
        "097",
        "098",
        "101",
        "102",
        "103",
        "104",
        "105",
        "106",
        "108",
        "111",
        "112",
        "113",
        "121",
        "122",
        "123",
        "131",
        "132",
        "141",
        "142",
        "143",
        "151",
        "152",
        "153",
        "154",
        "155",
        "162",
        "163",
        "164",
        "171",
        "172",
        "173",
        "181",
        "182",
        "183",
        "184",
        "185",
        "187",
        "188",
        "191",
        "192",
        "201",
        "202",
        "204",
        "205",
        "402",
        "404",
        "407",
        "501",
        "503",
        "601",
        "602",
        "603",
        "604",
        "609",
        "611",
        "612",
        "613",
        "614",
        "702",
        "703",
        "941",
        "961",
        "962",
        "963",
        "965",
        "966",
        "971",
        "972",
        "973",
        "974",
        "975",
        "976",
        "977",
        "978",
        "979"
  ],
  "HFB": [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "40",
        "50",
        "60",
        "61",
        "70",
        "94",
        "96",
        "97"
  ]
}
